import React from 'react';

import Tag from './AbstractTag';

Tag.parser.registerTag(
  'h6',
  class extends Tag {
    constructor(renderer, settings = {}) {
      super(renderer, settings);

      this.STRIP_OUTER = true;
    }

    toReact() {
      return <h6>{this.getComponents()}</h6>;
    }
  }
);
